module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fe5afd6776eac0f7724b132a9ff5057d.svg";